// Slugs are generated from the course title and transmission as entered in
// the admin panel, so renaming or adding a course needs no code change.
function slugify(text) {
  return String(text || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getCourseSlug(course) {
  const base = slugify(course?.title);
  const transmission = slugify(course?.cartype);
  // Manual/Automatic variants often share a title, so add the transmission
  // unless the title already says it.
  if (transmission && !base.split('-').includes(transmission)) {
    return `${base}-${transmission}`;
  }
  return base;
}

export function findCourseBySlug(courses, slug) {
  if (!Array.isArray(courses) || !slug) return null;
  const target = String(slug).toLowerCase();
  return (
    courses.find((course) => getCourseSlug(course) === target) || null
  );
}
